import * as PatternFly from '@patternfly/react-core';

const patternFlyComponents = {
  AboutModal: PatternFly.AboutModal,
  Accordion: PatternFly.Accordion,
  Alert: PatternFly.Alert,
  ApplicationLauncher: PatternFly.ApplicationLauncher,
  Avatar: PatternFly.Avatar,
  Backdrop: PatternFly.Backdrop,
  BackgroundImage: PatternFly.BackgroundImage,
  Badge: PatternFly.Badge,
  Brand: PatternFly.Brand,
  Breadcrumb: PatternFly.Breadcrumb,
  Bullseye: PatternFly.Bullseye,
  Button: PatternFly.Button,
  Card: PatternFly.Card,
  Checkbox: PatternFly.Checkbox,
  ChipGroup: PatternFly.ChipGroup,
  ClipboardCopy: PatternFly.ClipboardCopy,
  ContextSelector: PatternFly.ContextSelector,
  DataList: PatternFly.DataList,
  Dropdown: PatternFly.Dropdown,
  EmptyState: PatternFly.EmptyState,
  Expandable: PatternFly.Expandable,
  Form: PatternFly.Form,
  FormSelect: PatternFly.FormSelect,
  Gallery: PatternFly.Gallery,
  Grid: PatternFly.Grid,
  InputGroup: PatternFly.InputGroup,
  Label: PatternFly.Label,
  Level: PatternFly.Level,
  List: PatternFly.List,
  LoginPage: PatternFly.LoginPage,
  Modal: PatternFly.Modal,
  Nav: PatternFly.Nav,
  NotificationBadge: PatternFly.NotificationBadge,
  OptionsMenu: PatternFly.OptionsMenu,
  Page: PatternFly.Page,
  Pagination: PatternFly.Pagination,
  Popover: PatternFly.Popover,
  Progress: PatternFly.Progress,
  Radio: PatternFly.Radio,
  Select: PatternFly.Select,
  SkipToContent: PatternFly.SkipToContent,
  Split: PatternFly.Split,
  Stack: PatternFly.Stack,
  Switch: PatternFly.Switch,
  Tabs: PatternFly.Tabs,
  Text: PatternFly.Text,
  TextArea: PatternFly.TextArea,
  TextInput: PatternFly.TextInput,
  Title: PatternFly.Title,
  Toolbar: PatternFly.Toolbar,
  Tooltip: PatternFly.Tooltip,
  Wizard: PatternFly.Wizard
};

export default patternFlyComponents;